import { render, staticRenderFns } from "./PointReading.vue?vue&type=template&id=5823542a&scoped=true"
import script from "./PointReading.vue?vue&type=script&lang=js"
export * from "./PointReading.vue?vue&type=script&lang=js"
import style0 from "./PointReading.vue?vue&type=style&index=0&id=5823542a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5823542a",
  null
  
)

export default component.exports